import React, {useEffect, useState} from 'react';
import { withRouter } from 'react-router-dom';
import './CDRsTable.css'; // Import the CSS file
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPhoneAlt,faUser } from '@fortawesome/free-solid-svg-icons'; // Import icons
import ReactAudioPlayer from 'react-audio-player'; // Import ReactAudioPlayer
import moment from 'moment'; 
import axios from 'axios';


const CDRsTable = (props) => {
    const record = props.location.state?.record;
    const [transcriptions, setTranscriptions] = useState([]);
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
        console.log(record);
        if (record && record.transcription_ids) {
            fetchTranscriptions();
        }
        else{
            console.log('no record')
        }
    }, [record]);
    
    const fetchTranscriptions = async () => {
        setLoading(true);
        try {
            const headers = {
                'Content-Type': 'application/json',
                // Add any authentication headers if needed
            };
            
            const payLoad = {
                transcription_ids: record.transcription_ids
            }
            const response = await axios.post(`${process.env.REACT_APP_API_GATEWAY_URL}/transcriptions`, payLoad, {headers});
            setTranscriptions(response.data || []);
        } catch (error) {
            console.error("Error fetching transcriptions:", error);
            setTranscriptions([]);
        } finally {
            setLoading(false);
        }
    };
    
    if (!record) {
        return <div className="no-data">No data to display.</div>;
    }
    

    // Generate direction-based icon logic
    let directionIcon = <a href={`sip:${record.destination}?dialAction=autoCall`} className="call-status inbound-hover">
        <FontAwesomeIcon
            icon={faPhoneAlt}
            className="back-icon"

        />
    </a>

    const tableData = record.ans_call_flow.map((row, index) => (
        <tr key={index}>
            <td>{row.callingnumber}</td>
            <td>{row.dialednumber}</td>
            <td>{row.target || 'N/A'}</td>
            <td>{row.talktime_duration || 'N/A'}</td>
            <td>{row.initiation || 'N/A'}</td>
        </tr>
    ));

    // Simply display the raw timestamp from API and add 1 hour for UK time
    console.log("API timestamp:", record.time_stamp, "Type:", typeof record.time_stamp);
    
    // Extract date and time parts from the raw string and add 1 hour for UK time
    const timestampString = record.time_stamp || "";
    const datePart = timestampString.substring(0, 10); // Get YYYY-MM-DD part
    let timePart = timestampString.substring(11, 19); // Get HH:MM:SS part
    
    // Add 1 hour for UK time
    const timeParts = timePart.split(':');
    let hour = parseInt(timeParts[0]) + 1;
    const minute = timeParts[1];
    const second = timeParts[2];
    
    // Handle hour overflow (if hour becomes 24 or more)
    if (hour >= 24) {
        hour = hour - 24;
    }
    
    // Convert to 12-hour format
    let period = 'AM';
    if (hour >= 12) {
        period = 'PM';
        if (hour > 12) {
            hour = hour - 12;
        }
    }
    if (hour === 0) {
        hour = 12;
    }
    
    // Format the time back in 12-hour format
    timePart = `${hour}:${minute} ${period}`;

    return (
        <div className="cdr-table-container">
            {/* Header with Back Icon */}
            <div className="header-container">
                <FontAwesomeIcon
                    icon={faArrowLeft}
                    className="back-icon"
                    onClick={() => props.history.goBack()}
                />
                <h3 className="header-title">Calls</h3>
            </div>

            {/* Call Summary Section */}
            <h1 style={{fontSize:20, width: "100%", textAlign: "center", fontWeight:"700"}} 
            className={record.direction === "Inbound" ? "inbound-call" : record.direction === "Outbound" ? "outbound-call" : "missed-call"}>
                {record.direction}
            </h1>
            <div className="call-summary">
                {
                    record.name ?
                        <div className="call-summary-icon">
                            <span>
                                {record.name.split(' ').map((n) => n[0]).join('')}
                            </span>
                        </div>
                    :
                    <div className="call-user-icon">
                        <span>
                            <FontAwesomeIcon icon={faUser} />
                        </span>
                    </div>
                }
                <div className="call-summary-details">

                    <p className="call-summary-name">{record.name || '#'}</p>
                    <p className="call-summary-extension">{record.destination}</p>
                    <p className="call-summary-timestamp">
                        {datePart} {timePart}
                    </p>
                </div>
                <div className="call-summary-action">{directionIcon}</div>
            </div>
            <table className="cdr-table">
                <thead>
                    <tr>
                        <th>Originator</th>
                        <th>Dialed</th>
                        <th>Target</th>
                        <th>Talk Time</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>{tableData}</tbody>
            </table>
            {/* Call Recording */}
            {record.recording_url && (
                <div className="call-recording">
                    <ReactAudioPlayer
                        src={record.recording_url}
                        controls
                        style={{ width: '100%' }}
                    />
                </div>
            )}

            {/* Transcriptions Section */}
            {record.transcription_ids && (
                <div className="transcriptions-section">
                    <h3 className="section-title">Transcriptions</h3>
                    {loading ? (
                        <p>Loading transcriptions...</p>
                    ) : (
                        <div>
                            {transcriptions.length > 0 ? (
                                transcriptions.map((t, index) => (
                                    <div key={index} className="mb-2 p-2 border rounded">
                                        <strong>Transcription:</strong> {t.transcription}
                                    </div>
                                ))
                            ) : (
                                <p>No transcriptions available.</p>
                            )}
                        </div>
                    )}
                </div>
            )}
            {!record.transcription_ids && (
                <div className="mt-5transcriptions-section">
                    <h3 className="section-title mt-5">Transcriptions</h3>
                    <p>No transcriptions available for this call.</p>
                </div>
            )}

            {/* Call Flow Table */}
           
        </div>
    );
};

export default withRouter(CDRsTable);